export default "__VITE_ASSET__45f97725__"